"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _consts = require("./../consts.js");

var __jsx = _react.default.createElement;

var WrapperConsole = _styledComponents.default.div.withConfig({
  displayName: "OzBody__WrapperConsole",
  componentId: "sc-whcll2-0"
})(["\n  font-size: 12px;\n  font-family: 'Be Vietnam Pro', sans-serif;\n  font-weight: 400;\n  line-height: 18px;\n  letter-spacing: 0.5px;\n  color: #303030;\n\n  bold, b{\n    font-weight: 600;\n  }\n\n  a, a:hover{\n    text-decoration: none;\n  }\n\n  &, & * {\n    box-sizing: border-box;\n  }\n\n  html,body{\n    margin: 0px;\n  }\n\n  *{\n    scrollbar-color: ", " transparent;\n    scrollbar-width: thin;\n  }\n  ::-webkit-scrollbar {\n     width: 6px;\n  }\n  ::-webkit-scrollbar-track {\n     background: transparent;\n  }\n  ::-webkit-scrollbar-thumb {\n     background: ", "4D;\n  }\n"], _consts.CHARCOAL, _consts.CHARCOAL);

var WrapperWeb = _styledComponents.default.div.withConfig({
  displayName: "OzBody__WrapperWeb",
  componentId: "sc-whcll2-1"
})(["\n  font-size: 18px;\n  font-family: 'Be Vietnam Pro', sans-serif;\n  font-weight: 300;\n  line-height: 28px;\n  letter-spacing: 0.5px;\n  color: #717171;\n\n  a, a:hover{\n    text-decoration: none;\n  }\n\n  &, & * {\n    box-sizing: border-box;\n  }\n\n  html,body{\n    margin: 0px;\n  }\n\n  *{\n    scrollbar-color: ", " transparent;\n    scrollbar-width: thin;\n  }\n  ::-webkit-scrollbar {\n     width: 6px;\n  }\n  ::-webkit-scrollbar-track {\n     background: transparent;\n  }\n  ::-webkit-scrollbar-thumb {\n     background: ", "4D;\n  }\n"], _consts.CHARCOAL, _consts.CHARCOAL);

var OzBody = function OzBody(_ref) {
  var _ref$area = _ref.area,
      area = _ref$area === void 0 ? "console" : _ref$area,
      children = _ref.children;

  switch (area) {
    case "console":
      return __jsx(WrapperConsole, null, children);

    case "web":
      return __jsx(WrapperWeb, null, children);

    default:
      return __jsx(_react.default.Fragment, null, children);
  }
};

var _default = OzBody;
exports.default = _default;